import { useState, useEffect } from 'react'

interface Position {
  coords: {
    latitude: number
    longitude: number
  }
}

interface PositionError {
  code: number
  message: string
}

export const useGeolocation = () => {
  const [position, setPosition] = useState<Position | null>(null)
  const [error, setError] = useState<PositionError | null>(null)
  const [isMobile, setIsMobile] = useState<boolean>(false)
  useEffect(() => {
    isMobile &&
      navigator.geolocation.getCurrentPosition(
        (position) => setPosition(position),
        (error) => setError(error)
      )
  }, [isMobile])

  useEffect(() => {
    const mobileRegex =
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i
    const mobileUserAgent = navigator.userAgent
    setIsMobile(mobileRegex.test(mobileUserAgent))
  }, [])

  return { position, error }
}
